/** @format */

import React, { FC, useEffect, useState } from "react";
import { Form } from "antd";
import UIModal from "../../../ui/Modal";
import { UITextArea } from "../../../ui/Textarea";
import { UIText } from "../../../ui/Text";
import { UIButton } from "../../../ui/Button";
import {
  TIntermittentAction,
  TIntermittentCommunication,
} from "../../../../redux-modules/declarations/maps/intermittentCommunications";
import { ACTION_META, fmtDay, fmtShift, fullName } from "../constants";

interface Props {
  communication?: TIntermittentCommunication;
  action?: TIntermittentAction;
  loading: boolean;
  onCancel: () => void;
  onConfirm: (note?: string) => void;
}

/** Conferma di un'azione manuale, con nota (obbligatoria dove richiesto dal backend). */
export const ActionModal: FC<Props> = ({ communication, action, loading, onCancel, onConfirm }) => {
  const [form] = Form.useForm();
  const [note, setNote] = useState("");

  const communicationId = communication?.id;
  useEffect(() => {
    form.resetFields();
    setNote("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action, communicationId]);

  if (!action || !communication) return <></>;

  const meta = ACTION_META[action];

  const handleOk = async (): Promise<void> => {
    try {
      await form.validateFields();
      onConfirm(note.trim() || undefined);
    } catch (e) {}
  };

  return (
    <UIModal
      visible={!!action}
      title={meta.title}
      onCancel={onCancel}
      destroyOnClose
      footer={[
        <UIButton key="cancel" onClick={onCancel}>
          Indietro
        </UIButton>,
        <UIButton
          key="ok"
          type="primary"
          danger={meta.danger}
          loading={loading}
          onClick={handleOk}
          data-cy="intermittent-action-confirm"
        >
          {meta.okText}
        </UIButton>,
      ]}
    >
      <div style={{ marginBottom: 12 }}>
        <UIText strong>{fullName(communication)}</UIText>
        <br />
        <UIText type="secondary">
          {fmtDay(communication.work_date)} · turno {fmtShift(communication)}
        </UIText>
      </div>
      <p style={{ marginBottom: 16 }}>{meta.description}</p>
      <Form form={form} layout="vertical">
        <Form.Item
          name="note"
          label={meta.noteRequired ? "Nota" : "Nota (facoltativa)"}
          rules={meta.noteRequired ? [{ required: true, whitespace: true, message: "La nota è obbligatoria" }] : []}
          style={{ marginBottom: 0 }}
        >
          <UITextArea
            rows={3}
            maxLength={2000}
            placeholder={meta.notePlaceholder || "Aggiungi una nota"}
            value={note}
            onChange={(e): void => setNote(e.target.value)}
          />
        </Form.Item>
      </Form>
    </UIModal>
  );
};
